import * as React from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export interface CollapsibleSectionProps {
  header: string | React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  header, children, defaultOpen = true }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  const toggleCollapse = () => { setOpen((prev) => !prev); };

  return (
    <Box>
      <Box onClick={toggleCollapse} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', userSelect: 'none' }} >
        <Box sx={{ mr: 1 }}> {open ? <ExpandLessIcon /> : <ExpandMoreIcon />} </Box>
          {typeof header === 'string' ? (<Typography variant="subtitle1">{header}</Typography> ) : (header)}
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ mt: 1, ml: 4 }}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default CollapsibleSection;